import React, { useCallback } from "react";
import ReactDOM from "react-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import Fab from "@mui/material/Fab";
import useApp from "../../hooks/useApp";

const JumboCustomizerButton = ({
  icon,
  onClick,
  position = "right",
  ariaLabel = "Customizer",
  sx = {},
}) => {
  const { customizerVisibility, setCustomizerVisibility } = useApp();

  const toggleCustomizerVisibility = useCallback(() => {
    setCustomizerVisibility(!customizerVisibility);
  }, [setCustomizerVisibility, customizerVisibility]);

  return ReactDOM.createPortal(
    <Fab
      size="medium"
      color="primary"
      aria-label={ariaLabel}
      onClick={onClick || toggleCustomizerVisibility}
      sx={{
        position: "fixed",
        [position]: 0,
        zIndex: 101,
        width: 50,
        height: 44,
        p: (theme) => theme.spacing(1, 1, 1, 1.5),
        borderRadius: position === "right" ? "24px 0 0 24px" : "0 24px 24px 0",
        backgroundImage: (theme) =>
          `linear-gradient(${position === "right" ? "-135deg" : "135deg"}, ${
            theme.palette.primary.main
          }, ${theme.palette.secondary.main})`,
        "&:hover": {
          backgroundImage: (theme) =>
            `linear-gradient(${position === "right" ? "-135deg" : "135deg"}, ${
              theme.palette.secondary.main
            }, ${theme.palette.primary.main})`,
        },
        ...sx, // Let sx prop control top/bottom positioning
      }}
    >
      {icon ? (
        icon
      ) : (
        <SettingsIcon
          sx={{
            animation: "move 2s infinite linear",
            "@keyframes move": {
              from: { transform: "rotate(0deg)" },
              to: { transform: "rotate(360deg)" },
            },
          }}
        />
      )}
    </Fab>,
    document.getElementsByTagName("body")[0]
  );
};

export default JumboCustomizerButton;
